import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useMemo,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import { LIGHT } from '../utilities/constants';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeSwitchProvider = ({ children }) => {
  const [theme, setTheme] = useState(LIGHT);

  useEffect(() => {
    const root = window.document.documentElement;
    root.dataset.theme = theme;
  }, [theme]);

  const toggleTheme = useCallback((selectedTheme, options = {}) => {
    const { persist = true } = options;

    if (persist) {
      localStorage.setItem('theme', selectedTheme);
    }

    setTheme(selectedTheme);
  }, []);

  const contextValue = useMemo(
    () => ({ theme, toggleTheme }),
    [theme, toggleTheme]
  );

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeSwitchProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
